
<template>
    <div>
        <vxe-modal width="80vw" height="600" title="选择分析目标" v-model="dialogchangeEidVisible" destroy-on-close show-zoom resize
            transfer draggable>
            <div class="main-content" :style="{ backgroundImage: 'url(' + contHearerBg + ')' }">
                <div class="contentHeader">
                    <div class="main-title">小智分析</div>
                    <div class="tab-main">
                        <div class="tab-item">
                            <div v-for="(item, index) in arrTab" :class="item.active ? 'tab active' : 'tab'"
                                @click="changeTab(item.value)">
                                <div class="txt">{{ item.name }}</div>
                            </div>
                        </div>
                    </div>
                    <v-autocomplete background-color="#fff" class="searchbox" :search-input.sync="search"
                        @compositionstart="onCompositionStart" @compositionend="onCompositionEnd" v-model="organization"
                        :items="optionList" :autofocus="searchautofocus" label="" hide-details outlined dense  :hide-no-data="hidenodata"
                        placeholder="请输入关键字" @input="btnSelect">
                        <template #append-outer>
                            <v-btn depressed color="warning" @click="pageTo" :loading="isPageTo">开启分析</v-btn>
                        </template>
                    </v-autocomplete>


                    <el-row class="hotsearch">
                        <el-col class="title" :span="2">
                            <div>小智</div>
                            <div>推荐</div>
                        </el-col>
                        <el-col class="keys" :span="22">
                            <div v-show="curTab == 'organization'">
                                <el-link v-for="(item, index) in hotOrgKeyWord" @click="queryOrgHotWord(item)">{{ item.name
                                }}</el-link>
                            </div>
                            <div v-show="curTab == 'product'">
                                <el-link v-for="(item, index) in hotProductKeyWord" @click="queryProductHotWord(item)">{{
                                    item.productName }}</el-link>
                            </div>

                        </el-col>
                    </el-row>
                    <el-row class="hotsearch">
                        <el-col class="title" :span="2">
                            <div>历史</div>
                            <div>搜索</div>
                        </el-col>
                        <el-col class="keys" :span="22">
                            <div v-show="curTab == 'organization'">
                                <el-link v-for="(item, index) in OrghistoryList" @click="btnhistorypageTo(item)">{{
                                    item.fullName
                                }}</el-link>
                            </div>
                            <div v-show="curTab == 'product'">
                                <el-link v-for="(item, index) in ProhistoryList" @click="btnhistorypageTo(item)">{{
                                     item.fullName }}</el-link>
                            </div>

                        </el-col>
                    </el-row>

                </div>
            </div>
        </vxe-modal>
    </div>
</template>


<script>
import Bg from "@/assets/img/bigScreen/bg.png";
import contHearerBg from "@/assets/img/bigScreen/bg1.jpg";
import apiAxios from "@/config/apiAxios";
export default {
  name: "changeEid",
  components: {},
  props: {
    isopenUrl: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogchangeEidVisible: false,
      Bg: Bg,
      contHearerBg: contHearerBg,
      optionList: [],
      organization: "",
      search: "",
      hidenodata:true,// 首次隐藏下拉无数据
      timeout: null,
      eid: "",
      fullName: "",
      arrTab: [
        {
          name: "上市公司",
          active: true,
          value: "organization",
          placeholder: "请输入机构名称",
          lexicon: "organizationFull"
        },
        {
          name: "非上市公司",
          active: false,
          value: "product",
          placeholder: "请输入机构名称",
          lexicon: "bondShort"
        },
        {
          name: "证券产品",
          active: false,
          value: "product1",
          placeholder: "请输入机构名称",
          lexicon: "bondShort"
        },
        {
          name: "证券项目",
          active: false,
          value: "product2",
          placeholder: "请输入机构名称",
          lexicon: "bondShort"
        },
        {
          name: "行业、板块、产业",
          active: false,
          value: "product3",
          placeholder: "请输入机构名称",
          lexicon: "bondShort"
        },
        {
          name: "专业服务团队",
          active: false,
          value: "product4",
          placeholder: "请输入机构名称",
          lexicon: "bondShort"
        }
        //   { "name": "查项目", "active": false, "value": "item", "placeholder": "请输入项目名称", "lexicon": "" },
      ],
      searchautofocus: false,
      searchLabel: "查机构",
      curLexicon: "organizationFull",
      curTab: "organization",
      hotOrgKeyWord: [],
      hotProductKeyWord: [],
      hotItemKeyWord: [],
      curSelect: "",
      isPageTo: false,
      OrghistoryList:
        localStorage.getItem("decsisionSupporthistorySearch_Org") || [],
      ProhistoryList:
        localStorage.getItem("decsisionSupporthistorySearch_Pro") || [],
      autocompleteLock: false
    };
  },
  methods: {
    onCompositionStart() {
      this.autocompleteLock = true;
    },
    onCompositionEnd(e) {
      //  e.composing = false;
      this.autocompleteLock = false;
      let val = e.currentTarget._value;

      if (val && val !== this.organization && !this.autocompleteLock) {
        this.querySelections(val);
      }
    },
    autoinput(val) {
      console.log(val);
    },
    showDialog() {
      this.curSelect = "";
      this.eid = "";
      this.fullName = "";
      this.optionList = [];
      this.OrghistoryList =
        JSON.parse(localStorage.getItem("decsisionSupporthistorySearch_Org")) ||
        [];
      this.ProhistoryList =
        JSON.parse(localStorage.getItem("decsisionSupporthistorySearch_Pro")) ||
        [];
      this.isPageTo = false;
      this.dialogchangeEidVisible = true;
      this.getHotOrgWord();
      // this.getHotProductWord();
    },
    changeTab(val) {
      for (let k in this.arrTab) {
        if (this.arrTab[k].value == val) {
          this.arrTab[k].active = true;
          this.curTab = val;
          // this.placeholder = this.arrTab[k].placeholder
          this.curLexicon = this.arrTab[k].lexicon;
          this.searchLabel = this.arrTab[k].name;
          this.organization = "";
          this.eid = "";
          this.fullName = "";
          this.optionList = [];
          this.curSelect = "";
          this.searchautofocus = false;
          this.hidenodata=true;
        } else {
          this.arrTab[k].active = false;
        }
      }
    },
    querySelections(val) {
      if (val != "") {
        const pattern = /[`~!@#$^\-&*()=|{}':;',\\\[\]\.<>\/?~！@#￥……&*（）——|{}【】'；：""'。，、？\s]/g;
        val = val.replace(pattern, "");
      }
      this.loading = true;
      let _params = [
        { $match: { word: { $regex: "" + val + "" } } },
        { $group: { _id: "$pos" } },
        { $limit: 100 }
      ];

      let that = this;
      // 全部公司
      if (this.curTab == "product") {
        let _url = `${
          config.serverUrl
        }/cmcf/v1/organization/A0001?name=${val}&limit=10`;

        apiAxios.get(_url, {}, _r => {
          that.loading = false;
          let restaurants = [];
          if (_r.code == 200) {
            if (_r.data) {
              _r.data.forEach(_d => {
                restaurants.push({
                  value: _d.GE8100005E,
                  text: _d.GE8100005E
                });
              });
            }
            that.optionList = restaurants;
          } else {
            this.$notify({ type: "danger", message: "获取信息失败" });
          }
        });
      } else if (this.curTab == "organization") {
        // 上市公司
        let _url = `${config.serverUrl}/cmbs/v1/jump/thdb/lexicon/${
          this.curLexicon
        }/aggregate`;
        apiAxios.post(_url, _params, _r => {
          that.loading = false;
          let restaurants = [];
          if (_r.code == 200) {
            if (_r.data) {
              _r.data.forEach(_d => {
                let _conf = _d._id.split("+");
                if (_conf.length >= 2) {
                  restaurants.push({
                    value: _d._id,
                    text: _conf[1]
                  });
                }
              });
            }

            that.optionList = restaurants;
          }
        });
      }
    },
    btnhistorypageTo(item) {
      if (this.$props.isopenUrl) {
        this.dialogchangeEidVisible = false;
        localStorage.setItem(
          "decsisionSupportCurPara",
          JSON.stringify({
            eid: item.eid,
            fullName: item.fullName
          })
        );
        let newpage = this.$router.resolve({
          name: "smartAnalyze"
        });
        window.open(newpage.href, "_blank");
        return;
      }
      this.$EventBus.$emit("changeEid", {
        eid: item.eid,
        fullName: item.fullName
      });
      this.dialogchangeEidVisible = false;
    },
    // 跳转，关闭弹窗
    pageFinished() {
      // 缓存处理
      let curTab = this.curTab;
      let historylist = [];
      let lckey = "";
      if (curTab == "product") {
        lckey = "decsisionSupporthistorySearch_Pro";
        historylist = this.ProhistoryList;
      } else if (curTab == "organization") {
        lckey = "decsisionSupporthistorySearch_Org";
        historylist = this.OrghistoryList;
      }
      let curObj = {
        eid: this.eid,
        fullName: this.fullName,
        ctime: $func.getToday(true)
      };
      // 为空，直接插入
      if (historylist.length == 0) {
        historylist.push(curObj);
      } else {
        // 是否已存在，存在则替换
        let index = historylist.findIndex(x => x.eid == this.eid);
        if (index > -1) {
          historylist = historylist.splice(index, 1);
        }
        // 超过10，
        if (historylist.length == 10) {
          historylist = historylist.splice(9, 1);
        }
        historylist.unshift(curObj);
      }

      localStorage.setItem(lckey, JSON.stringify(historylist));
      if (this.$props.isopenUrl) {
        this.dialogchangeEidVisible = false;
        localStorage.setItem(
          "decsisionSupportCurPara",
          JSON.stringify({
            eid: this.eid,
            fullName: this.fullName
          })
        );
        let newpage = this.$router.resolve({
          name: "smartAnalyze"
        });
        window.open(newpage.href, "_blank");
        return;
      }
      this.$EventBus.$emit("changeEid", {
        eid: this.eid,
        fullName: this.fullName
      });
      this.dialogchangeEidVisible = false;
    },

    pageTo() {
      if (this.curSelect != "") {
        this.isPageTo = true;
        // 全部公司
        if (this.curTab == "product") {
          // 查询eid
          let url = `${config.serverUrl}/apm/v1/ability/DA000030?name=${
            this.curSelect
          }`;
          apiAxios.get(url, {}, _r => {
            this.isPageTo = false;
            if (_r.code == 200) {
              if (_r.data.eid) {
                let eid = _r.data.eid;
                this.eid = eid;
                this.fullName = this.curSelect;
                this.pageFinished();
              }
            } else {
              this.$notify({ type: "danger", message: "获取eid信息失败" });
            }
            console.log(_r);
          });
        } else if (this.curTab == "organization") {
          let _conf = this.curSelect.split("+");
          this.eid = _conf[0];
          this.fullName = _conf[1];
          this.pageFinished();
        }
        // let newLink = window.open('', '_blank');

        // let newUrl = this.$router.resolve({
        //     path: "/apps/bigScreen/decsisionSupportVega",
        //     query: { val: this.curSelect }
        // });
        // newLink.location.href = newUrl.href;
      } else {
        this.$notify({ type: "danger", message: "请先选择公司" });
        return;
      }
    },

    // 选中
    btnSelect(val) {
      this.curSelect = val;
    },

    /**
     * 获取热点机构搜索词
     * @param response
     */

    getHotOrgWord() {
      let _url = `${
        config.serverUrl
      }/basiceg/v1/json/announce02/wordCloud.json`;

      let _that = this;
      apiAxios.get(_url, {}, _r => {
        _that.hotOrgKeyWord = _r[0].options.series[0].data.slice(0, 30);
      });
    },

    /**
     * 获取热点产品搜索词
     * @param date 日期格式 2022-06-08
     * @param response
     */

    getHotProductWord() {
      let _that = this;
      let _url = `${
        config.serverUrl
      }/v1/cmp/nlp/lexicon/segmentation/hotProducts`;
      let date = "2022-06-08";
      let _params = {
        mode: "segmentation",
        text: date
      };
      apiAxios.post(_url, _params, _r => {
        let word = [];
        if (_r.length && _r[0].values) {
          _r[0].values.forEach(_d => {
            let _conf = _d.split("+");
            if (_conf.length >= 2) {
              word.push({
                eid: _conf[0],
                productName: _conf[1]
              });
            }
          });
        }
        _that.hotProductKeyWord = word;
      });
    },

    getHotItemWord() {
      let _that = this;

      let param = {
        limit: 20,
        sort: "updated_time desc"
      };
      this.hotItemKeyWord = [];
      cmewApi.getApiByTag(
        "lexicon",
        "hotProjects",
        param,
        _r => {
          if (_r && _r.length) {
            for (let k in _r) {
              _that.hotItemKeyWord.push({
                name: _r[k].word,
                eid: _r[k].pos.split("+")[0]
              });
            }
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    /**
     * 热门产品
     * @param {*} item
     */
    queryProductHotWord(item) {
      console.log(item);
    },
    /**
     * 热门机构
     * @param {*} item
     */
    queryOrgHotWord(item) {
      let val = item.name;
      if (val != "") {
        const pattern = /[`~!@#$^\-&*()=|{}':;',\\\[\]\.<>\/?~！@#￥……&*（）——|{}【】'；：""'。，、？\s]/g;
        val = val.replace(pattern, "");
      }
      let _url = `${
        config.serverUrl
      }/cmbs/v1/jump/thdb/lexicon/organizationFull/aggregate`;
      let _params = [
        { $match: { word: { $regex: "" + val + "" } } },
        { $group: { _id: "$pos" } },
        { $limit: 100 }
      ];

      apiAxios.post(_url, _params, _r => {
        if (_r.code == 200) {
          let cur = _r.data[0];
          if (cur) {
            //  this.curSelect = cur._id;
            let _conf = cur._id.split("+");
            this.eid = _conf[0];
            this.fullName = _conf[1];
            this.pageFinished();
            // this.$EventBus.$emit("changeEid", { eid: _conf[0], fullName: _conf[1] });
            // this.dialogchangeEidVisible = false;
            // this.pageTo();
            // this.btnSelect(cur._id)
          }
        }
      });
    }
  },
  watch: {
    search(val) {
      console.log("aulock", this.autocompleteLock);
      if (val && val !== this.organization && !this.autocompleteLock) {
        this.hidenodata=false;
        this.querySelections(val);
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/skin/var.less";

/deep/ .vxe-modal--content {
  padding: 0;
}

// z-index: 999;

.main-content {
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  flex: 1;
  // padding-top: 10px;
  height: 100%;
  // background-position: 50%;
  background-size: cover;
  position: relative;

  .contentHeader {
    // background-color: #eeeef4;
    padding: 10px;
    width: 75%;
    margin: 0 auto;
    text-align: center;

    .main-title {
      display: inline-block;
      margin-bottom: 33px;
      margin-top: 36px;
      font-size: 48px;
      line-height: 64px;
      letter-spacing: 8px;
      text-indent: 7px;
      color: @workbench-background-color;
    }

    .tab-main {
      .tab-item {
        .tab {
          display: inline-block;
          // width: 80px;
          padding: 3px 6px;
          line-height: 1.4;
          margin-right: 32px;
          margin-bottom: 14px;
          border-radius: 2px;
          font-size: 16px;
          background-color: transparent;
          cursor: pointer;
          color: @workbench-background-color;

          .txt {
            position: relative;
          }

          &.active {
            color: #0084ff;
            background-color: @workbench-background-color;

            .txt {
              &:after {
                position: absolute;
                left: 35%;
                top: 100%;
                content: "";
                width: 0;
                height: 0;
                margin-top: 2px;
                border-left: 8px solid transparent;
                border-right: 8px solid transparent;
                border-top: 8px solid @workbench-background-color;
              }
            }
          }

          &:hover {
            color: #0084ff;
            background-color: @workbench-background-color;

            .txt {
              &:after {
                position: absolute;
                left: 35%;
                top: 100%;
                content: "";
                width: 0;
                height: 0;
                margin-top: 2px;
                border-left: 8px solid transparent;
                border-right: 8px solid transparent;
                border-top: 8px solid @workbench-background-color;
              }
            }
          }
        }
      }
    }

    .searchbox {
      /deep/ .v-label--active {
        top: 15px;
      }

      /deep/ .v-input__append-outer {
        margin-top: 0px;
        margin-left: 0px;
      }

      /deep/.v-btn:not(.v-btn--round).v-size--default {
        height: 40px;
      }
    }

    .hotsearch {
      width: 100%;
      height: 56px;
      margin-top: 32px;
      text-align: left;
      font-size: 0;
      color: @workbench-background-color;
      overflow: hidden;

      .title {
        display: inline-block;
        height: 56px;
        border-radius: 4px;
        overflow: hidden;
        padding-top: 5px;
        text-align: center;
        font-size: 16px;
        letter-spacing: 4px;
        text-indent: 4px;
        line-height: 22px;
        background: @cmew-hotsearch-title-background;
      }

      .keys {
        padding-left: 20px;
        display: inline-block;
        height: 56px;
        vertical-align: top;
        text-align: left;

        .el-link {
          color: #font-color[light];
          display: inline-block;
          vertical-align: top;
          margin-right: 24px;
          margin-bottom: 10px;
          font-size: #font-size[normal];
          line-height: 22px;

          &:hover {
            color: @workbench-background-color !important;
          }
        }
      }
    }
  }
}
</style>
